/**
 * Score/percentile color palette for guess display.
 * Single source of truth for web and mobile.
 * 20 colors mapping 0-5%, 5-10%, ... 95-100%.
 */
export const SCORE_COLORS = [
'#b0224a',
'#c63a3f',
'#e05238',
'#f06a32',
'#f38a3a',
'#f09b3a',
'#f4b32f',
'#ddb64a',
'#b5b06f',
'#7f9f8f',
'#4fc3d8',
'#6fd8f0',
'#8feaff',
'#a6f4ff',
'#66ffd2',
'#6dffbf',
'#4cffad',
'#1aff9a',
'#00f28b',
'#00e95a',

];

/**
 * Returns hex color for a percentile (0-100).
 * @param {number} percentile - 0 = coldest, 100 = target
 * @returns {string} hex color
 */
export function getColorFromPercentile(percentile) {
  const p = Math.max(0, Math.min(100, percentile));
  const index = Math.floor(p / 5);
  return SCORE_COLORS[Math.min(index, SCORE_COLORS.length - 1)];
}

/**
 * Display transform: raw score (0-100 from JSON) -> displayed value (0-99.99 or 100).
 * Formula: displayed = min(99.99, (score/100)^25 * 100). Winning (score >= 100) shows 100.
 * @param {number} score - raw similarity score 0-100 from daily word JSON
 * @returns {number} 0-100 value for color/display (100 only for winning)
 */
export function getDisplayedScore(score) {
  if (score >= 100) return 100;
  return Math.min(99.99, 100 * Math.pow(score / 100, 25));
}

/**
 * Format displayed score as percentage string (e.g. "99%", "99.5%", "100%").
 * @param {number} score - raw similarity score 0-100 from daily word JSON
 * @returns {string}
 */
export function formatDisplayedScore(score) {
  const d = getDisplayedScore(score);
  if (d >= 100) return '100%';
  if (d < 98) return Math.floor(d) + '%';
  if (d < 99) {
    const t = Math.floor(d * 10);
    return `${Math.floor(t / 10)}.${t % 10}%`;
  }
  const t = Math.floor(d * 100);
  return `${Math.floor(t / 100)}.${Math.floor((t % 100) / 10)}${t % 10}%`;
}
